export default __webpack_public_path__ + "static/media/property_1_3.e01c83ad.webp";